import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Dropdown, Modal } from 'antd';
import intl from 'react-intl-universal';
import ContextMenu from './Content';

export interface MenuProps {
  position: { left: number; top: number };
  onOk: (value: any) => void;
  [propsName: string]: any;
}

const RIGHT_POSITION_STYLE = {
  width: '100%',
  position: 'absolute',
  right: '-180px',
  top: 0,
  border: '1px solid #d9d9d9',
};

const LEFT_POSITION_STYLE = {
  width: '100%',
  position: 'absolute',
  left: '-180px',
  top: 0,
  border: '1px solid #d9d9d9',
};

const RightContextMenu: React.FC<any> = forwardRef((props, ref) => {
  const win: any = window;

  const imageMenuRef = useRef<any>(null);

  const [positionStyle, setPositionStyle] = useState<any>(RIGHT_POSITION_STYLE);

  const getPositionStyle = (event: any) => {
    const clientWidth = document?.documentElement?.clientWidth;
    const clientX = event?.clientX;

    const menuWidth = document.getElementById('context-menu')?.clientWidth;

    const selectWidth = document.getElementById('select-tag')?.clientWidth;

    if (
      clientWidth &&
      clientX &&
      menuWidth &&
      selectWidth &&
      clientWidth - clientX < menuWidth + selectWidth
    ) {
      setPositionStyle(LEFT_POSITION_STYLE);
    } else {
      setPositionStyle(RIGHT_POSITION_STYLE);
    }
    return positionStyle;
  };

  useEffect(() => {
    getPositionStyle(imageMenuRef.current.event);
  }, []);

  useEffect(() => {
    try {
      win?.electron?.ipcRenderer.on('reach-tab-max-num', () => {
        Modal.warning({
          title: intl.get('cpm_content_menu_tab_full'),
          content: intl.get('cpm_content_menu_client_tab_reach_upper_limit_tips'),
          okText: intl.get('app_confirm_confirm_btn'),
        });
      });
    } catch (error) {
      //
    }
  }, []);

  useImperativeHandle(ref, () => ({
    imageMenuRef,
  }));

  const handleMenuClick = (e: any) => {
    try {
      switch (e.key) {
        case '1': // 在新标签页中打开
          const url = (imageMenuRef.current.event.target as any)?.href;
          win?.electron?.ipcRenderer?.openNewTab(url);
          break;
        default:
          break;
      }
    } catch (error) {
      //
    }
  };

  const items: MenuProps['items'] = [
    {
      label: intl.get('cpm_content_menu_open_in_new_tab'),
      key: '1',
    },
  ];

  return (
    <>
      <ContextMenu ref={imageMenuRef} targetElementClassName="order-detail" menu={null}>
        <Dropdown menu={{ items, onClick: handleMenuClick }} open>
          <div> </div>
        </Dropdown>
      </ContextMenu>
    </>
  );
});

export default RightContextMenu;
